// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15cIv","title":"styles_title__1P4og"};